import { BanksPage } from 'features/banks';

export const TechOperatorBanksPage: React.FC = () => <BanksPage />;
